/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <BrowserRouter >
      <App />
    </BrowserRouter> */}
<BrowserRouter basename={process.env.REACT_APP_BASE_NAME || '/'} >
  <App />
</BrowserRouter>

  </React.StrictMode>
);

// basename={process.env.REACT_APP_BASE_NAME}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
